
// File: index.ts

import { HOW_ITS_DONE } from './HowItsDone';
import { GOLDEN } from './Golden';
import { TAKEDOWN } from './Takedown';
import { YOUR_IDOL } from './YourIdol';
import { SODA_POP } from './SodaPop';
import { FREE } from './Free';
import { WHAT_IT_SOUNDS_LIKE } from './WhatItSoundsLike';
import { WILL_HE_LET_THE_FIRE_GO_OUT } from './WillHeLetTheFireGoOut';
import { APT } from './APT';
import { HuntrixSong } from './types';

export const SONG_REGISTRY: Record<string, HuntrixSong> = {
    [HOW_ITS_DONE.id]: HOW_ITS_DONE,
    [GOLDEN.id]: GOLDEN,
    [TAKEDOWN.id]: TAKEDOWN,
    [YOUR_IDOL.id]: YOUR_IDOL,
    [SODA_POP.id]: SODA_POP,
    [FREE.id]: FREE,
    [WHAT_IT_SOUNDS_LIKE.id]: WHAT_IT_SOUNDS_LIKE,
    [WILL_HE_LET_THE_FIRE_GO_OUT.id]: WILL_HE_LET_THE_FIRE_GO_OUT,
    [APT.id]: APT,
};

export const SONGS = Object.values(SONG_REGISTRY);

export type { HuntrixSong, MusicalData } from './types';
